import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddTeacherComp from "./Component/AddTeacherComp"


const AddTeacher =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddTeacherComp />
            
        </div>
        <Footer />
        </>
    )
}

export default AddTeacher